import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/auth/login',
    name: 'Login',
    component: () => import('@/views/Auth/LoginView.vue'),
    meta: { requiresAuth: false, layout: 'auth' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard/DashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/bandes',
    name: 'Bandes',
    component: () => import('@/views/Bandes/BandesView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/historique-bande/:id',
    name: 'HistoriqueBande',
    component: () => import('@/views/Bandes/HistoriqueBandeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/finances',
    name: 'Finances',
    component: () => import('@/views/Finances/FinancesView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/stocks',
    name: 'Stocks',
    component: () => import('@/views/Stocks/StocksView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/rh',
    name: 'RH',
    component: () => import('@/views/RH/RHView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import('@/views/Clients/ClientsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/inventaire',
    name: 'Inventaire',
    component: () => import('@/views/Inventaire/InventaireView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/configuration',
    name: 'Configuration',
    component: () => import('@/views/Configuration/ConfigurationView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/prophylactique',
    name: 'Prophylactique',
    component: () => import('@/views/Prophylactique/ProphylactiqueView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: { name: 'Login' },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Garde de navigation : vérifier l'authentification et les rôles
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()

  // Vérifier la validité de la session avant chaque navigation
  if (authStore.isAuthenticated && !authStore.validateSession()) {
    // Session expirée - rediriger vers login
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }

  // Vérifier l'authentification
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }

  // Vérifier les droits admin
  if (to.meta.requiresAdmin) {
    const userRole = authStore.user?.role?.toLowerCase() || ''
    if (userRole !== 'admin') {
      // Rediriger vers le dashboard si l'utilisateur n'est pas admin
      next({ name: 'Dashboard' })
      return
    }
  }

  // Rediriger depuis login si déjà authentifié
  if (to.name === 'Login' && authStore.isAuthenticated) {
    next({ name: 'Dashboard' })
    return
  }

  next()
})

export default router

